// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style */
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"

import Booking from "../../../../../../records/Booking"
import { BOOKING_STATUSES } from "../../../../../../consts/booking"

const trackInvalidBookingData = (booking: Booking) => {
  // @ts-expect-error: Flow to TS migration.
  if (!Object.values(BOOKING_STATUSES).includes(booking.status) && booking.status !== null) {
    cuckoo.critical(cuckooEvents.MANAGE_MAPPER_UNSUPPORTED_STATUS, {
      // @ts-expect-error: Flow to TS migration.
      status: booking.status,
      // @ts-expect-error: Flow to TS migration.
      bid: booking.id,
    })
  }

  /*
   * Track if there is baggage abid without
   * corresponding entry in additionalServices
   */
  // @ts-expect-error: Flow to TS migration.
  const wrongBaggagesAbid = booking.baggages.filter(
    // @ts-expect-error: Flow to TS migration.
    (bag) =>
      bag.additionalBookingId &&
      // @ts-expect-error: Flow to TS migration.
      !booking.additionalServices.find((a) => a.id === bag.additionalBookingId),
  )

  if (wrongBaggagesAbid.length) {
    cuckoo.track(cuckooEvents.MMB_ADDITIONAL_BAGS_WRONG_ABID, {
      // @ts-expect-error: Flow to TS migration.
      bid: booking.bid,
    })
  }
}

export default trackInvalidBookingData
